import React from 'react';
import translate from '@/lib/intl/translate';
import {
  CommsResponsePropType,
  EmailAttachments,
  EmailParticipants,
  replaceInlineImages,
  useSanitizeEmailBody,
} from '@/modules/Comms';
import { formatDate } from '@/utils/dates';
import ContentBody from './ContentBody';
import ContentDetails from './ContentDetails';

type EmailIntegrationContentProps = {
  email: unknown;
};

export default function EmailIntegrationContent({
  email,
}: EmailIntegrationContentProps) {
  const {
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'attachments' does not exist on type 'unk... Remove this comment to see the full error message
    attachments: allAttachments = [],
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'bccRecipients' does not exist on type 'u... Remove this comment to see the full error message
    bccRecipients,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'body' does not exist on type 'unknown'.
    body: rawBody = '',
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'ccRecipients' does not exist on type 'un... Remove this comment to see the full error message
    ccRecipients,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'commsId' does not exist on type 'unknown... Remove this comment to see the full error message
    commsId,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'messageDatetime' does not exist on type ... Remove this comment to see the full error message
    messageDatetime,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'toRecipients' does not exist on type 'un... Remove this comment to see the full error message
    toRecipients,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'sender' does not exist on type 'unknown'... Remove this comment to see the full error message
    sender,
    // @ts-expect-error TS(2339) TODO(ts-migrate): Property 'subject' does not exist on type 'unknown... Remove this comment to see the full error message
    subject,
  } = email;

  const [bodyWithImages, attachments] = React.useMemo(
    () =>
      replaceInlineImages([
        rawBody,
        // The attachments get mutated by this function so create a new array
        // and pass that in.
        [...allAttachments],
      ]),
    [allAttachments, rawBody],
  );

  const sanitizedBody = useSanitizeEmailBody(bodyWithImages);
  const contentItems = React.useMemo(
    () => [
      {
        title: translate('EMAIL_SUBJECT'),
        value: subject,
        className: 'col-span-full',
      },
      {
        title: translate('DATE_LABEL'),
        className: 'col-span-full',
        value: formatDate(messageDatetime, 'PPPPp'),
      },
      {
        title: translate('EMAIL_FROM'),
        className: 'col-span-full',
        value: <EmailParticipants participants={sender} />,
      },
      {
        title: translate('EMAIL_TO'),
        className: 'col-span-full',
        value: toRecipients && (
          <EmailParticipants participants={toRecipients} />
        ),
      },
      {
        title: translate('EMAIL_CC'),
        className: 'col-span-full',
        value: ccRecipients && (
          <EmailParticipants participants={ccRecipients} />
        ),
      },
      {
        title: translate('EMAIL_BCC'),
        className: 'col-span-full',
        value: bccRecipients && (
          <EmailParticipants participants={bccRecipients} />
        ),
      },
      {
        title: translate('EMAIL_MESSAGE'),
        className: 'col-span-full',
        value: (
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizedBody,
            }}
          />
        ),
      },
      {
        className: 'col-span-full rounded bg-grey-100 p-3',
        key: 'email-attachments',
        value: !!attachments.length && (
          <EmailAttachments attachments={attachments} />
        ),
      },
    ],
    [
      sanitizedBody,
      ccRecipients,
      commsId,
      messageDatetime,
      toRecipients,
      sender,
      subject,
    ],
  );

  return (
    <ContentBody entityId={commsId}>
      <ContentDetails
        contentItems={contentItems}
        title={translate('FEED_SLIDER_DETAILS_TITLE')}
      />
    </ContentBody>
  );
}

EmailIntegrationContent.propTypes = {
  email: CommsResponsePropType.isRequired,
};
